import { hasCookie } from './utils';

const routes = {
    csrf: 'auth/csrf-cookie',
    token: 'auth/token', // token auth
    logout: 'auth/logout',
    me: 'me',
};

async function fetchCSRFToken() {
    await window.centralAxios.get(routes.csrf);
}

async function token(credentials) {
    await fetchCSRFToken();
    const response = await window.centralAxios.post(routes.token, credentials);
    return response.data;
}

async function logout() {
    await window.centralAxios.post(routes.logout);
}

function me() {
    return window.centralAxios.get(routes.me);
}

function hasXSRFToken() {
    return hasCookie('XSRF-TOKEN');
}

export default {
    fetchCSRFToken,
    token,
    logout,
    me,
    hasXSRFToken,
};
